import * as Styled from "./style";

export const Supplement = () => {
  return (
    <Styled.UlNavList>
      <li>
        <Styled.SpanMandatory>*</Styled.SpanMandatory>
        マークは入力必須項目です。
      </li>

      <li>商品タイトル1つにつき、投稿できるレビューは1件です。</li>

      <li>商品によっては、複数商品やシリーズを通しての投稿となる場合があります。</li>

      <li>絵文字など環境依存文字は、文字化けする可能性があります。</li>

      <li>
        書き方や詳細については、
        <Styled.AnchorUlTextLink
          href="https://support.dmm.com/"
          target="_blank"
          rel="noopener noreferrer"
          color="BLUE900"
        >
          ヘルプページ
        </Styled.AnchorUlTextLink>
        をご覧ください。
      </li>

      <li>
        不具合や視聴方法についての質問は、
        <Styled.AnchorUlTextLink
          href="https://inquiry.dmm.com/"
          target="_blank"
          rel="noopener noreferrer"
          color="BLUE900"
        >
          サポートセンター
        </Styled.AnchorUlTextLink>
        からお問い合わせください。
      </li>
    </Styled.UlNavList>
  );
};
